import React from "react";
import {connect} from "react-redux";
import NumberDisplay from "../NumberDisplay";
import {Bid, Lot, Participant} from "@nextlot/core/webcast/data/data_types_definitions";
import {ReduxActiveWebcastSubStateType} from "@nextlot/core/webcast/redux/reducerActiveWebcast";
import {ReduxWebcastCurrentRoundType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRound";
import {ReduxWebcastCurrentRoundBiddingType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRoundBidding";
import {RoundStopTypeEnum, RoundTypeEnum} from "@nextlot/core/webcast/data/WebcastDataDomain";




type RootCmpPropsType = {
    currentRound: ReduxWebcastCurrentRoundType,
    currentRoundBidding: ReduxWebcastCurrentRoundBiddingType,
    lotsMapById: Map<number, Lot>,
    participantsMapByUserId: Map<number, Participant>,
}


function renderWinningBid(winningBid:Bid) {
    return (
        <div className="p-3 d-flex flex-row">
            <p>Winning Bid:</p>
            <div className="ps-3">
                <h4 className="">{NumberDisplay.formatValueCents(winningBid.value)}</h4>
                <h5 className="">{winningBid.bidderDisplay}</h5>
            </div>
        </div>
    )
}


function renderContent(props:RootCmpPropsType) {
    const {currentRound, currentRoundBidding, lotsMapById, participantsMapByUserId} = props;

    if ((currentRound.stopType === RoundStopTypeEnum.SOLD || currentRound.stopType === RoundStopTypeEnum.PENDING) &&
        (currentRound.roundType === RoundTypeEnum.GROUP_CHOICE || currentRound.roundType === RoundTypeEnum.GROUP_CHOICE_REOPEN) &&  // over-kill to check roundType too, but for consistency clarity
        (currentRoundBidding.choiceLotsSelection && currentRoundBidding.choiceLotsSelection.length)) {
        // render *closing* a CHOICE|CHOICE_REOPEN after lots were assigned by clerk

        if (currentRound.stopType === RoundStopTypeEnum.SOLD) {
            //
        }
        else {
            // PENDING
        }

        return (
            <React.Fragment>
                <h3 className="py-1 px-3 bg-success text-white">Lots assigned</h3>

                {currentRoundBidding.choiceLotsSelection
                    .map(pair => {
                        const lotId = pair[0];
                        const lot: Lot = lotsMapById.get(lotId);
                        const userId = pair[1];
                        const participant: Participant | Bid = participantsMapByUserId.get(userId) || currentRoundBidding.highestBid;

                        return { lot, participant };
                    })
                    .sort((a:{lot:Lot, participant:Participant}, b:{lot:Lot, participant:Participant}) => (a.lot.orderIdx - b.lot.orderIdx))
                    .map(({ lot, participant }:{lot:Lot, participant:Participant}) => {
                        return (
                            <div key={lot.id}>#{lot.number} {'\u27F9'} {participant.bidderDisplay}</div>
                        )
                    })
                }
            </React.Fragment>
        );

    }
    else {
        // render *stopping* any type of round

        switch (currentRound.stopType) {
            case RoundStopTypeEnum.CANCEL:
                return <h3 className="py-1 px-3 bg-dark text-white">CANCEL</h3>;

            case RoundStopTypeEnum.NO_SALE:
                return <h3 className="py-1 px-3 bg-danger text-white">NO SALE</h3>;

            case RoundStopTypeEnum.SOLD:
                return (
                    <React.Fragment>
                        <h3 className="py-1 px-3 bg-success text-white">SOLD!</h3>
                        {renderWinningBid(currentRoundBidding.highestBid)}
                    </React.Fragment>
                );

            case RoundStopTypeEnum.PENDING:
                return (
                    <React.Fragment>
                        <h3 className="py-1 px-3 bg-warning text-dark">PENDING</h3>
                        {renderWinningBid(currentRoundBidding.highestBid)}
                    </React.Fragment>
                );
            default:
                if (process.env.NODE_ENV === "development")
                    return <h1>!!! INVALID Round.stopType: {currentRound.stopType}</h1>
        }
    }


}



const ClerkRoundStopInfoCmp = (props:RootCmpPropsType) => {

    /*
    render logic:

    if stopType==SOLD|PENDING && roundType == CHOICE|CHOICE_REOPEN && currentRoundBidding.choiceLotsSelection.length
        => show lots assigned to each Participant
    else
        => show stopType + winningBid
     */

    return (
        <div className="p-3 d-flex flex-column">
            {renderContent(props)}
        </div>
    );
};

export default connect(({ activeWebcast }: {activeWebcast:ReduxActiveWebcastSubStateType}) => {
    return {
        currentRound: activeWebcast.webcastCurrentRound,
        currentRoundBidding: activeWebcast.webcastCurrentRoundBidding,
        lotsMapById: activeWebcast.webcastAuctionData.lotsMapById,
        participantsMapByUserId: activeWebcast.webcastParticipants.mapByUserId,
    };
})(ClerkRoundStopInfoCmp);


